import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/landTract"
import TextArea from "components/TextArea"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import { toast } from "react-toastify"
import _ from "lodash"
import NumberFormat from "react-number-format"

class AddLandTract extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			fields: fields,
		}
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			acreage: Yup.number().required("Required"),
			property: Yup.number().required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	options = (f, name) => {
		let ret = []
		this.props.payload.public[name].forEach((v) => {
			if (f.values.properties && f.values.properties.includes(v.property)) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	optionsAlpha = (name) => {
		let opts = _.map(this.props.payload.public[name], (v) => {
			return { label: v.name, value: v.id }
		})

		opts = _.sortBy(opts, "label")

		return opts
	}

	render() {
		if (this.props.payloadStatus) {
			const { open } = this.props
			return (
				<div>
					<Modal open={open} onClose={this.props.onClose} center classNames={{ modal: "modalForm" }}>
						<h3>Add Land Tract</h3>
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("addLandTract", values).then((data) => {
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.props.close()
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div className="editUser">
									<div className="content">
										<Form>
											<ul className="form__list">
												<li className={fieldStatus("name", f)}>
													<label htmlFor="name">
														Name <sup>*</sup>
													</label>
													{f.errors.name && f.touched.name && (
														<div className="form__message">{f.errors.name}</div>
													)}
													<Field name="name" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("acreage", f)}>
													<label htmlFor="acreage">Acreage</label>
													{f.errors.acreage && f.touched.acreage && (
														<div className="form__message">{f.errors.acreage}</div>
													)}
													<NumberFormat
														name="acreage"
														float={true}
														className="form__input"
														onValueChange={(v) => f.setFieldValue("acreage", v.value)}
														onBlur={() => f.setFieldTouched("acreage", true)}
													/>
												</li>
												<li className={fieldStatus("property", f, false, false, true)}>
													<label htmlFor="property">
														Property <sup>*</sup>
													</label>
													{f.errors.property && f.touched.property && (
														<div className="form__message">{f.errors.property}</div>
													)}
													<ReactSelect
														name={`property`}
														options={this.optionsAlpha("properties")}
														value={f.values.property}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
											</ul>
											<input
												type="submit"
												value="Submit"
												className={this.submitClasses(f.isValid)}
											/>
										</Form>
									</div>
								</div>
							)}
						</Formik>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddLandTract)
